import React, { useEffect, useState } from 'react';
import { Box, Typography, Link, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Avatar  } from '@mui/material';
import axios from 'axios';
import { useHistory } from 'react-router-dom';


function Page2SubPageA() {
 const history = useHistory();
 const [openDialog, setOpenDialog] = useState(false);
 const [activePostId, setActivePostId] = useState(null);
 const [voteType, setVoteType] = useState(null); 
 const [comment, setComment] = useState("");


 const [govComments, setGovComments] = useState([]);
 useEffect(() => {
     axios.get('/posts/topGov')
     .then(res => setGovComments(res.data))
     .catch(err => console.error(err));
 }, []);


const toggleBillVote = async (billId) => {
   try {
       const res = await axios.post(`/bill/${billId}/upvote`);
       const { upvotes, voted } = res.data;


       setGovComments(prevBills => {
           const updated = prevBills.map(bill =>
               bill._id === billId
               ? { ...bill, upvoteCount: upvotes, voted }
               : bill
           );


       // Sort again after update
       return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
       });
   } catch (err) {
       console.error('Error toggling vote:', err);
   }
   };


const toggleScotusVote = async (scotusCaseId) => {
  try {
      const res = await axios.post(`/scotusCase/${scotusCaseId}/upvote`);
      const { upvotes, voted } = res.data;


      setGovComments(prevCases => {
          const updated = prevCases.map(scotusCase =>
              scotusCase._id === scotusCaseId
              ? { ...scotusCase, upvoteCount: upvotes, voted }
              : scotusCase
          );


      // Sort again after update
      return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
      });
  } catch (err) {
      console.error('Error toggling vote:', err);
  }
  };


const toggleCalPropVote = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/upvote`);
           const { upvotes, voted } = res.data;


           setGovComments(prevCalProp => ({
               ...prevCalProp,
           upvoteCount: upvotes,
           voted,
           }));


       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


const toggleStateBillVote = async (calBillId) => {
 try {
     const res = await axios.post(`/calBill/${calBillId}/upvote`);
     const { upvotes, voted } = res.data;


     setGovComments(prevCalBills => {
         const updated = prevCalBills.map(calBill =>
             calBill._id === calBillId
             ? { ...calBill, upvoteCount: upvotes, voted }
             : calBill
         );


     // Sort again after update
     return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
     });
 } catch (err) {
     console.error('Error toggling vote:', err);
 }
 };


const toggleBillPass = async (billId) => {
       try {
           const res = await axios.post(`/bill/${billId}/pass`);
           const { upvotes, billVoted } = res.data;


           setGovComments(prev =>
               prev.map(bill => bill._id === billId ? { ...bill, passCount: upvotes, billVoted } : bill)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const toggleBillNoPass = async (billId) => {
       try {
           const res = await axios.post(`/bill/${billId}/noPass`);
           const { upvotes, billVoted } = res.data;


           setGovComments(prev =>
               prev.map(bill => bill._id === billId ? { ...bill, noPassCount: upvotes, billVoted } : bill)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
  };


const toggleForPetitioner = async (scotusCaseId) => {
       try {
           const res = await axios.post(`/scotusCase/${scotusCaseId}/petitioner`);
           const { upvotes, scotusCaseVoted } = res.data;




           setGovComments(prev =>
               prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, petitionerCount: upvotes, scotusCaseVoted } : scotusCase)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




 const toggleForRespondent = async (scotusCaseId) => {
       try {
           const res = await axios.post(`/scotusCase/${scotusCaseId}/respondent`);
           const { upvotes, scotusCaseVoted } = res.data;




           setGovComments(prev =>
               prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, respondentCount: upvotes, scotusCaseVoted } : scotusCase)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


const toggleStateBillNoPass = async (calBillId) => {
      try {
          const res = await axios.post(`/calBill/${calBillId}/noPass`);
          const { upvotes, stateBillVoted } = res.data;


          setGovComments(prev =>
              prev.map(calBill => calBill._id === calBillId ? { ...calBill, noPassCount: upvotes, stateBillVoted } : calBill)
          );
      } catch (err) {
          console.error('Error toggling vote:', err);
      }
  };


const toggleStateBillPass = async (calBillId) => {
      try {
          const res = await axios.post(`/calBill/${calBillId}/pass`);
          const { upvotes, stateBillVoted} = res.data;


          setGovComments(prev =>
              prev.map(calBill => calBill._id === calBillId ? { ...calBill, passCount: upvotes, stateBillVoted } : calBill)
          );
      } catch (err) {
          console.error('Error toggling vote:', err);
      }
  };


const toggleNo = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/no`);
           const { upvotes, calPropVoted } = res.data;




           setGovComments(prevCalProp => ({
               ...prevCalProp,
               noCount: upvotes,
               calPropVoted,
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const toggleYes = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/yes`);
           const { upvotes, calPropVoted} = res.data;


           setGovComments(prevCalProp => ({
               ...prevCalProp,
               yesCount: upvotes,
               calPropVoted,
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




const handleSubmitBillVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }


       try {
           await axios.post(`/bill/${activePostId}/comment`, { text: comment });


           if (voteType === "Pass") {
               await toggleBillPass(activePostId);
           } else {
               await toggleBillNoPass(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };


const handleSubmitScotusVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }




       try {
           await axios.post(`/scotusCase/${activePostId}/comment`, { text: comment });




           if (voteType === "For Petitioner") {
               await toggleForPetitioner(activePostId);
           } else {
               await toggleForRespondent(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };


const handleSubmitStateBillVote = async () => {
      if (!voteType || !comment.trim() || !activePostId) {
          alert("Please choose vote type and enter a comment.");
          return;
      }


      try {
          await axios.post(`/calBill/${activePostId}/comment`, { text: comment });


          if (voteType === "No Pass") {
              await toggleStateBillNoPass(activePostId);
          } else {
              await toggleStateBillPass(activePostId);
          }
          setOpenDialog(false);
          setComment("");
          setVoteType(null);
      } catch (err) {
          console.error(err);
      }
  };


const handleSubmitCalPropVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }


       try {
           await axios.post(`/calProp/${activePostId}/comment`, { text: comment });


           if (voteType === "No") {
               await toggleNo(activePostId);
           } else {
               await toggleYes(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };



 let currPostType = "";
 const handleOpenDialog = (postId, postType) => {
       setActivePostId(postId);
       setOpenDialog(true);
       currPostType = postType;
   };


const toggleStateBillCommentVote = async (commentId) => {
       try {
           // hit backend endpoint that toggles a vote
           const res = await axios.post(`/calBillComments/${commentId}/upvote`);


           /*setComment(prev => ({
               ...prev,
               upvotes: res.data.upvotes,
               voted: res.data.voted
           }));*/
           setGovComments(prev =>
                prev.map(post => {
                  if (post.type !== "stateBill") return post;

                  return {
                    ...post,
                    comments: post.comments.map(c =>
                      c._id === commentId
                        ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                        : c
                    )
                  };
                })
              );
       } catch(err) {
           console.error("Vote error", err);
       }
   };


const toggleCalPropCommentVote = async (commentId) => {
      try {
          // hit backend endpoint that toggles a vote
          const res = await axios.post(`/calPropComments/${commentId}/upvote`);


          /*setComment(prev => ({
              ...prev,
              upvotes: res.data.upvotes,
              voted: res.data.voted
          }));*/
          setGovComments(prev =>
                prev.map(post => {
                  if (post.type !== "calProp") return post;

                  return {
                    ...post,
                    comments: post.comments.map(c =>
                      c._id === commentId
                        ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                        : c
                    )
                  };
                })
              );
      } catch(err) {
          console.error("Vote error", err);
      }
  };


const toggleBillCommentVote = async (commentId) => {
       try {
            // hit backend endpoint that toggles a vote
            //const res = await axios.post(`/post/${postId}/upvote`);
            const res = await axios.post(`/billComments/${commentId}/upvote`);


            // update <posts> in react state so ui rerenders
            // setPosts(prev => ...) receives the previous array of posts and must return a new array
            // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           /*setComment((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );*/
           /*setComment(prev => ({
                ...prev,
                upvotes: res.data.upvotes,
                voted: res.data.voted
            }));*/
            /*setGovComments(prevComments =>
              prevComments.map(c =>
                c._id === commentId
                  ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                  : c
              )
            );*/
            setGovComments(prev =>
              prev.map(post => {
                if (post.type !== "bill") return post;

                return {
                  ...post,
                  comments: post.comments.map(c =>
                    c._id === commentId
                      ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                      : c
                  )
                };
              })
            );


       } catch(err) {
           console.error("Vote error", err);
       }
   };
 
   const toggleScotusCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);


               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           /*setComment((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );*/
              setGovComments(prev =>
                prev.map(post => {
                  if (post.type !== "scotus") return post;

                  return {
                    ...post,
                    comments: post.comments.map(c =>
                      c._id === commentId
                        ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                        : c
                    )
                  };
                })
              );


       } catch(err) {
           console.error("Vote error", err);
       }
   };

   function updateReplyRecursive(replies, replyId, newData) {
      return (replies || []).map((r) => {
        if (r._id === replyId) {
          return { ...r, ...newData }; // update this reply
        }
        return {
          ...r,
          replies: updateReplyRecursive(r.replies, replyId, newData), // recurse deeper
        };
      });
    }

    const toggleBillReplyVote = async (replyId, id) => {
      try {
        const res = await axios.post(`/bill/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        /*setGovComments((prevComments) =>
          prevComments.map((c) => ({
            ...c,
            replies: updateReplyRecursive(c.replies, replyId, { 
              upvotes: replyUpvotes, 
              voted: replyVoted 
            }),
          }))
        );*/
        /*setGovComments((prevComments) =>
          prevComments.map((c) => {
            if (c._id === replyId) {
              // case 1: the comment itself is the reply being updated
              return { ...c, upvotes: replyUpvotes, voted: replyVoted };
            }
            // case 2: look for it inside replies
            return {
              ...c,
              replies: updateReplyRecursive(c.replies, replyId, {
                upvotes: replyUpvotes,
                voted: replyVoted,
              }),
            };
          })
        );*/
        setGovComments((prev) =>
          prev.map((post) => {
            if (post.type !== "bill" || post._id !== id) return post;

            return {
              ...post,
              comments: post.comments.map((c) => {
                if (c._id === replyId) {
                  // top-level reply is actually a comment
                  return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                }
                return {
                  ...c,
                  replies: updateReplyRecursive(c.replies, replyId, {
                    upvotes: replyUpvotes,
                    voted: replyVoted,
                  }),
                };
              }),
            };
          })
        );

      } catch (err) {
        console.error("Reply vote error", err);
      }
    };

    const toggleScotusReplyVote = async (replyId, id) => {
      try {
        const res = await axios.post(`/scotusCase/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        /*setGovComments((prevComments) =>
          prevComments.map((c) => ({
            ...c,
            replies: updateReplyRecursive(c.replies, replyId, { upvotes, voted }),
          }))
        );*/

        setGovComments((prev) =>
          prev.map((post) => {
            if (post.type !== "scotus" || post._id !== id) return post;

            return {
              ...post,
              comments: post.comments.map((c) => {
                if (c._id === replyId) {
                  // top-level reply is actually a comment
                  return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                }
                return {
                  ...c,
                  replies: updateReplyRecursive(c.replies, replyId, {
                    upvotes: replyUpvotes,
                    voted: replyVoted,
                  }),
                };
              }),
            };
          })
        );
      } catch (err) {
        console.error("Reply vote error", err);
      }
    };

    const toggleStateBillReplyVote = async (replyId, id) => {
       try {
        const res = await axios.post(`/calBill/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        /*setGovComments((prevComments) =>
            prevComments.map((c) => ({
              ...c,
              replies: updateReplyRecursive(c.replies, replyId, { upvotes, voted }),
            }))
          );
          */
         setGovComments((prev) =>
          prev.map((post) => {
            if (post.type !== "stateBill" || post._id !== id) return post;

            return {
              ...post,
              comments: post.comments.map((c) => {
                if (c._id === replyId) {
                  // top-level reply is actually a comment
                  return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                }
                return {
                  ...c,
                  replies: updateReplyRecursive(c.replies, replyId, {
                    upvotes: replyUpvotes,
                    voted: replyVoted,
                  }),
                };
              }),
            };
          })
        );
        } catch (err) {
          console.error("Reply vote error", err);
        }
      };

      const toggleCalPropReplyVote = async (replyId, id) => {
          try {
          const res = await axios.post(`/calProp/${id}/commentReplies/${replyId}/upvote`);
          const { replyUpvotes, replyVoted } = res.data;

          /*setGovComments((prevComments) =>
            prevComments.map((c) => ({
              ...c,
              replies: updateReplyRecursive(c.replies, replyId, { upvotes, voted }),
            }))
          );*/
          setGovComments((prev) =>
            prev.map((post) => {
              if (post.type !== "calProp" || post._id !== id) return post;

              return {
                ...post,
                comments: post.comments.map((c) => {
                  if (c._id === replyId) {
                    // top-level reply is actually a comment
                    return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                  }
                  return {
                    ...c,
                    replies: updateReplyRecursive(c.replies, replyId, {
                      upvotes: replyUpvotes,
                      voted: replyVoted,
                    }),
                  };
                }),
              };
            })
          );
          } catch (err) {
          console.error("Reply vote error", err);
          }
      };

const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };


const renderComments = (comments, parentText = null, parentUsername = null, parentId, postId, postType) => {
 return comments.flatMap((comment, i) => {
   const thisComment = (
     <Box
       key={comment._id || i}
       onClick={(e) => {
          e.stopPropagation(); 
          if (postType== "bill") {
            history.push(`/bill/${postId}/comments/${comment._id}`)
          } else if (postType == "scotus") {
            history.push(`/scotusCase/${postId}/comments/${comment._id}`)
          } else if (postType == "stateBill") {
            history.push(`/calBill/${postId}/comments/${comment._id}`)
          } else if (postType == "calProp") {
            history.push(`/calProp/${postId}/comments/${comment._id}`)
          }
        }
       }
       mt={2}
       p={2}
       border="1px solid #eee"
       borderRadius="6px"
       sx={{
          "&:hover": {
            //backgroundColor: "#eaeaea", // inner hover overrides
            //backgroundColor: "#f0f4f9", // inner hover overrides
            backgroundColor: "#e6edf7", // inner hover overrides
          },
        }}
     >
       {/* If this is a reply, show the parent text above */}
       {parentText && (
         <Box 
          onClick={(e) => {
              e.stopPropagation(); 
              if (postType== "bill") {
                history.push(`/bill/${postId}/comments/${parentId}`)
              } else if (postType == "scotus") {
                history.push(`/scotusCase/${postId}/comments/${parentId}`)
              } else if (postType == "stateBill") {
                history.push(`/calBill/${postId}/comments/${parentId}`)
              } else if (postType == "calProp") {
                history.push(`/calProp/${postId}/comments/${parentId}`)
              }
            }
          }
          mb={1} 
          p={1} 
          borderLeft="3px solid #aaa" 
          pl={2}
          sx={{
          "&:hover": {
            backgroundColor: "#d9e4f0", // inner hover overrides
          },
        }}
        >
           <Typography variant="caption" color="textSecondary">
             In reply to @{parentUsername}: {parentText}
           </Typography>
         </Box>
       )}


       {/* Main comment/reply */}
       <Box display="flex" alignItems="flex-start" gap={1}>
       	<Avatar
             		src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                    alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                    onClick={(e) => visitProfile(e, comment.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
       	/>
       	<Box>
              	<Typography variant="subtitle1" fontWeight="bold"
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                >
                    	{comment.author?.first_name && comment.author?.last_name
                                   ? `${comment.author.first_name} ${comment.author.last_name}`
                                   : 'Unknown Name'}
                     </Typography>
                     <Typography variant="body2" color="text.secondary"
                     onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                     >
                     	@{comment.author?.username || 'unknown'}
                     </Typography>


                     {/* Post content */}
                     <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                     	{comment.text}
                     </Typography>


                     {/* Date */}
                     <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                 {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                     </Typography>


              </Box>
       </Box>


       <Box mt={2} display="flex" alignItems="center" gap={1}>
          <Button
            size="small"
            variant={comment.voted ? "contained" : "outlined"}
            onClick={(e) => {
                e.stopPropagation();
                if (postType == "bill" && parentText == null) {
 	  		 		        toggleBillCommentVote(comment._id);
                } else if (postType == "bill" && parentText != null) {
                    toggleBillReplyVote(comment._id, postId);
 		 		        } else if (postType == "scotus" && parentText == null) {
 			 		          toggleScotusCommentVote(comment._id);
                } else if (postType == "scotus" && parentText != null) {
                    toggleScotusReplyVote(comment._id, postId);
 		 		        } else if (postType == "stateBill" && parentText == null) {
 			 		        toggleStateBillCommentVote(comment._id);
                } else if (postType == "stateBill" && parentText != null) {
                    toggleStateBillReplyVote(comment._id, postId);
 		 		        } else if (postType == "calProp" && parentText == null) {
 			 		        toggleCalPropCommentVote(comment._id);
                } else if (postType == "calProp" && parentText != null) {
                    toggleCalPropReplyVote(comment._id, postId);
		 		        }
              }
            }
          >
              ▲ {comment.voted ? "Unvote" : "Upvote"}
          </Button>
               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
        </Box>
     </Box>
   );


   // Recursively render replies but flatten them into the same level
   const childReplies =
     comment.replies?.length > 0
       ? renderComments(comment.replies, comment.text, comment.author.username, comment._id, postId, postType)
       : [];


   return [thisComment, ...childReplies];
 });
};

 return (
   <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>


           {/* Centered Buttons */}
           <Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion of the Intelligentsia
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/b/b2')}
                   >
                       Law
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/e')}
                   >
                       Hot Politics
                   </Button>
              </Box>
              
              {govComments.map((post, i) => {
                let leftCount = 0;
                let rightCount = 0;
                let votePercentage = 0;
                let offset = 0;

                if (post.type == "bill") {
                    leftCount = post.noPassCount || 0;
                    rightCount = post.passCount || 0;
                } else if (post.type == "scotus") {
                    leftCount = post.petitioner || 0;
                    rightCount = post.respondent || 0;
                } else if (post.type == "calProp") {
                    leftCount = post.noCount || 0;
                    rightCount = post.yesCount || 0; 
                } else if (post.type == "stateBill") {
                    leftCount = post.noCount || 0;
                    rightCount = post.yesCount || 0; 
                }

                if (rightCount > leftCount) {
                    votePercentage = rightCount/(rightCount+leftCount);
                } else if (leftCount > rightCount) {
                    votePercentage = leftCount/(rightCount+leftCount);
                }

                if (rightCount > leftCount) {
                    offset = votePercentage * 50; // move right
                } else if (leftCount > rightCount) {
                    offset = -votePercentage * 50; // move left
                }

                let tickColor = "blue";
                let postCommentsPage = ``;
                let leftVote = "";
                let rightVote = "";
                let docLink = ``;

                if (post.type == "bill") {
                    if (offset > 0) {
                        tickColor = "#00c853"; // right side
                    } else if (offset < 0) {
                        tickColor = "red"; // left side
                    }
                    postCommentsPage = `/bill/${post._id}/comments`;
                    leftVote = "No Pass Votes";
                    rightVote = "Pass Votes";
                } else if (post.type == "scotus") {
                    if (offset > 0) {
                        tickColor = "red"; // right side
                    } else if (offset < 0) {
                        tickColor = "red"; // left side
                    }
                    postCommentsPage = `/scotusCase/${post._id}/comments`;
                    leftVote = "For Petitioner";
                    rightVote = "For Respondent";
                } else if (post.type == "calProp") {
                    if (offset > 0) {
                        tickColor = "#00c853"; // right side
                    } else if (offset < 0) {
                        tickColor = "red"; // left side
                    }
                    postCommentsPage = `/calProp/${post._id}/comments`;
                    leftVote = "No";
                    rightVote = "Yes";
                } else if (post.type == "stateBill") {
                    if (offset > 0) {
                      tickColor = "red"; // right side
                    } else if (offset < 0) {
                      tickColor = "red"; // left side
                    }
                    postCommentsPage = `/calBill/${post._id}/comments`;
                    leftVote = "No Pass Votes";
                    rightVote = "Pass Votes";
                    docLink = `/api/bill/pdf/${post.doc_id}`;
                }

                const getPdfLink = (post) => {
                  switch (post.type) {
                    case "bill":
                      return { href: post.pdf, label: "View Bill" };
                    case "scotus":
                      return { href: post.pdfUrl, label: "View PDF" };
                    case "calProp":
                      return { href: `/api/calProp/pdf/${post.doc_id}`, label: "View Proposition" };
                    case "stateBill":
                      return { href: `/api/bill/pdf/${post.doc_id}`, label: "View PDF" };
                    default:
                      return null; // no link if type doesn’t match
                  }
                };
                const pdfLink = getPdfLink(post);

                const getVoteVars = (post) => {
                  switch (post.type) {
                    case "bill":
                      return {  
                        lCount: post.noPassCount,
                        rCount: post.passCount,
                        lLabel: "No Votes",
                        rLabel: "Yes Votes",
                      };
                    case "scotus":
                      return {  
                        lCount: post.petitionerCount,
                        rCount: post.respondentCount,
                        lLabel: "For Petitioner Votes",
                        rLabel: "For Respondent Votes",
                      };
                    case "calProp":
                      return {  
                        lCount: post.noCount,
                        rCount: post.yesCount,
                        lLabel: "No Votes",
                        rLabel: "Yes Votes",
                      };
                    case "stateBill":
                      return {  
                        lCount: post.noPassCount,
                        rCount: post.passCount,
                        lLabel: "No Pass Votes",
                        rLabel: "Pass Votes",
                      };
                    default:
                      return null;
                  }
                };
                const voteVar = getVoteVars(post);

                return (
                  <Box
                    key={i} // unique key for each list item
                    //onClick={() => history.push(postCommentsPage)}
                    onClick={(e) => {
                        e.stopPropagation(); 
                        if (post.type == "bill") {
                          history.push(`/bill/${post._id}/comments`)
                        } else if (post.type == "scotus") {
                          history.push(`/scotusCase/${post._id}/comments`)
                        } else if (post.type == "stateBill") {
                           history.push(`/calBill/${post._id}/comments`)
                        } else if (post.type == "calProp") {
                           history.push(`/calProp/${post._id}/comments`)
                        }
                      }
                    }
                    p={2} // padding inside box
                    my={2} // vertical margin between posts
                    border="1px solid #ccc" // light grey border
                    borderRadius="8px" // rounded corners
                    sx={{
                        position: "relative",
                        maxWidth: 900, // limit width
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                    }}
                  >
                    <Typography
                      fontWeight="bold"
                       sx={{
                          wordBreak: "break-word",
                          pr: "140px",
                          mb: 1
                        }}
                    >
                      {post.type === "bill" && post.title}
                      {post.type === "scotus" && post.name}
                      {post.type === "calProp" && post.title}
                      {post.type === "stateBill" && `${post.number}: ${post.title}`}
                    </Typography>

                    {post.type === "calProp" && post.propDescription && (
                      <Typography
                          fontWeight="regular"
                          sx={{
                            wordBreak: "break-word",
                            pr: "140px",
                            mb: 1
                            }}
                      >
                          {post.propDescription}
                      </Typography>
                    )} 
                    {post.type === "stateBill" && post.description && (
                      <Typography
                          fontWeight="regular"
                          sx={{
                            wordBreak: "break-word",
                            pr: "140px",
                            mb: 1
                            }}
                      >
                          {post.description}
                      </Typography>
                    )}
       
                    <Box
                      display="flex"
                      justifyContent="center"
                      sx={{
                          mb: 2,
                          //my: 1
                      }}
                    >
                      <Button
                          variant="outlined"
                          size="small"
                          onClick={(e) => {
                              e.stopPropagation(); 
                              handleOpenDialog(post._id, post.type)}
                          }
                          //sx={{ ml: 2.3 }}
                          //sx={{
                          //  ml: post.type === "calProp" || post.type === "scotus" ? -2.3 : 2.3, 
                          //}}
                          sx={{
                            ml: post.type === "calProp"
                              ? -1
                              : post.type === "scotus"
                              ? -2.3
                              : 2.3
                          }}
                      >
                          Vote
                      </Button>
                    </Box>

                    {/* Vote bar with tick */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ mb: 2 }}
                        >
                        <Typography variant="body2">{leftVote}</Typography>


                        {/* Bar with tick in middle */}
                        <Box
                            sx={{
                                position: "relative",
                                height: "2px",
                                backgroundColor: "#ccc",
                                width: "300px",
                                mx: 2
                            }}>
                                {/* Tick in the center */}
                                <Box sx={{
                                    position: "absolute",
                                    top: "-6px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: "2px",
                                    height: "14px",
                                    backgroundColor: "black"
                                }} />
                            
                            {/* Dynamic tick + percentage */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "-6px",
                                    left: `calc(50% + ${offset}%)`,
                                    transform: "translateX(-50%)",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                }}
                                >
                                {/* Tick */}
                                <Box sx={{
                                    width: "2px",
                                    height: "14px",
                                    backgroundColor: tickColor
                                }} />


                                {/* Percentage */}
                                <Typography
                                    variant="caption"
                                    sx={{ mt: "2px", fontSize: "0.7rem" }}
                                >
                                    {(votePercentage * 100).toFixed(0)}%
                                </Typography>
                                </Box>
                            </Box>
                            <Typography variant="body2">{rightVote}</Typography>
                    </Box>

                    {pdfLink && (
                        <Link
                            href={pdfLink.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {pdfLink.label}
                        </Link>
                    )}
 
                  {/* Upvote button & count */}
                  <Box mt={2} display="flex" alignItems="center" gap={1}>
                      <Button
                          size="small"
                          variant={post.voted ? "contained" : "outlined"}
                          onClick={(e) => {
                              e.stopPropagation();
                              if (post.type == "bill") {
                                  toggleBillVote(post._id);
                              } else if (post.type == "scotus") {
                                  toggleScotusVote(post._id);
                              } else if (post.type == "stateBill") {
                                  toggleStateBillVote(post._id);
                              } else if (post.type == "calProp") {
                                  toggleCalPropVote(post._id);
                              }
                          }
                        }
                       >
                            ▲ {post.voted ? "Unvote" : "Upvote"}
                      </Button>
                        <Typography variant="body2">{post.upvoteCount} Visibility Upvotes | {voteVar.lCount} {voteVar.lLabel} | {voteVar.rCount} {voteVar.rLabel}</Typography>
                  </Box>

                  {renderComments(post.comments, null, null, null, post._id, post.type)} 

                  </Box>
                  
                );
                
              })}

              <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
               <DialogTitle>Cast Your Power Vote</DialogTitle>
               <DialogContent>
                   <Box display="flex" gap={2} mb={2}>
                       <Button
                           variant={voteType === "Pass" ? "contained" : "outlined"}
                           onClick={() => setVoteType("Pass")}
                       >
                           Pass
                       </Button>
                       <Button
                           variant={voteType === "No Pass" ? "contained" : "outlined"}
                           onClick={() => setVoteType("No Pass")}
                       >
                           No Pass
                       </Button>
                   </Box>
                   <TextField
                       fullWidth
                       multiline
                       rows={3}
                       placeholder="Explain your power vote (required)"
                       value={comment}
                       onChange={(e) => setComment(e.target.value)}
                   />
               </DialogContent>
               <DialogActions>
                   <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                   <Button
                       variant="outlined"
                       onClick={ () => {
                        if (currPostType == "bill") {
                            handleSubmitBillVote()
                        } else if (currPostType == "scotus") {
                            handleSubmitScotusVote()
                        } else if (currPostType == "stateBill") {
                            handleSubmitStateBillVote()
                        } else if (currPostType == "calProp") {
                            handleSubmitCalPropVote()
                        }
 		                   }}
                        disabled={!comment || !voteType}
                   >
                       Submit Power Vote
                   </Button>
               </DialogActions>
           </Dialog>
    </div>
  );
}


export default Page2SubPageA;